const toggleOverlay = (show: boolean): HTMLDivElement | undefined => {
  const overlayEl = document.querySelector<HTMLDivElement>('[data-overlay]');
  if (!overlayEl) return;

  overlayEl.classList.toggle('md:opacity-0', !show);
  overlayEl.classList.toggle('md:pointer-events-none', !show);

  return overlayEl;
};

export default toggleOverlay;
